<div class="cbolui-cds cbolui-cds-blue-vis-id {{pageName}}">
    @if(pageDataObj){
    <!-- HERO BANNER START -->
    @if(pageName !== 'vac'){
    <div class="hero-placeholder" [ngClass]="{'loader': isBannerCallRequired}">
        @if(pageDataObj['heroBanner']['heroBannerData']) {
        <tds-hero-banner template="template1" [cardArtData]="pageDataObj?.heroBanner.cardArtData"
            [cardArtSizes]="pageDataObj?.heroBanner?.cardArtData?.cardArtSizes"
            (onLinkClick)="bannerCTAClicked($event, pageDataObj?.heroBanner?.contentID)"
            [heroBannerData]="pageDataObj?.heroBanner.heroBannerData"
            (footerLinkClick)="onPageLinkClick($event, 'hero-banner')"></tds-hero-banner>
        }
    </div>
    }
    <!-- HERO BANNER END-->
    <div id="page-container" class="d-flex flex-column container w-100" style="position: relative; z-index: 0;">
        <!-- CATEGORY NAVBAR START -->
        @if(pageDataObj['navBarData']){
        <section id="legal_zeta_tabs"
            class="citi-section d-flex flex-column align-items-stretch align-self-stretch justify-content-between gap-2">
            <tds-category-nav-bar [categoryTabs]="pageDataObj?.navBarData.categoryTabs"
                [selected]="pageDataObj?.navBarData.selectedNav"
                (selectedEvent)="categorySelection($event, pageDataObj?.navBarData.selectedNav)"></tds-category-nav-bar>
            <tds-legal-bar [legalBar]="pageDataObj?.legalBarData" (onClick)="onNavBarLinkClick($event)"
                srLegalReadLink="{{pageName ==='explore' ? '' : 'h1-category-header'}}"></tds-legal-bar>
        </section>
        }
        <!-- CATEGORY NAVBAR END -->
        <!-- PRODUCT LIST START -->
        @if(pageDataObj['cardData'].length > 0){
        <section id="group-cc-module" class="d-flex flex-column gap-5 w-100">
            <ng-container *ngFor="let obj of pageDataObj?.cardData; let i = index">
                <section [id]="'category-header_group_'+i"
                    class="citi-section card-stack d-flex flex-column align-items-start align-self-stretch justify-content-between gap-3">
                    @if(obj['categoryHeader']){
                    <div class="section-wrapper w-100 d-flex flex-column gap-1">
                        <div class="card-stack-header bold d-flex align-items-start w-100 flex-column flex-lg-row">
                            <tds-category-header [active]="obj?.categoryHeader?.active"
                                [headerLevel]="obj?.categoryHeader?.headerLevel"
                                [template]="obj?.categoryHeader?.template"
                                [headerText]="obj?.categoryHeader?.headerText.plaintext"
                                [headerAriaLabel]="obj?.categoryHeader?.headerAriaLabel"
                                [headerClassList]="obj?.categoryHeader?.headerClassList"
                                [headerLink]="obj?.categoryHeader?.headerLink"
                                (onLinkClick)="onNavBarLinkClick($event, obj?.productList, obj?.categoryHeader?.headerText.plaintext)"></tds-category-header>
                        </div>
                    </div>
                    }
                    @if(obj['chipsFilterData']){
                    <tds-filter-chips class="w-100" [chips]="obj.chipsFilterData?.filterChips"
                        [chipName]="obj?.chipsFilterData?.header" (onSelect)="onFilterChipSelect($event)"
                        [count]="obj.chipsFilterData?.productCount"></tds-filter-chips>
                    }
                    <div [id]="'card_group_'+i+'_section'" class="outer-container {{pageName}}"
                        [ngClass]="{'slider-wrapper': obj.sliderContainer || false}">
                        <div class="inner-container {{obj.template | lowercase}}"
                            [ngClass]="{'card-slider-container': obj.sliderContainer || false}" [id]="'scroll-box_' + i"
                            (touchstart)="swipe($event, [i,selectedIndex[i]], 'start')"
                            (touchend)="swipe($event, [i,selectedIndex[i]], 'end')">
                            <ng-container
                                *ngFor="let cardObj of (obj?.filterProductList || obj?.productList);let j = index;">
                                <div [id]="'card_group_'+i+'_section_'+j"
                                    class="flex-wrap box {{obj.template+'_container' | lowercase}}">
                                    @defer(on viewport; on idle){
                                    @if(cardObj['type'] === 'card') {
                                        <!-- VARIATION DATA START -->
                                        @if(cardObj?._variation !== 'master'){
                                        <div [innerHTML]="variationStartComment"></div>
                                        }
                                        <!-- CARD -->
                                        <tds-cc-module [template]="cardObj.template" [cardDetail]="cardObj.cardDetail"
                                            [flexCardDirection]="cardObj.flexCardDirection" [headerLevel]="'2'" [flexFlagDirection]="cardObj.flexFlagDirection"
                                            [flipChild]="cardObj.flipChild" [order]="cardObj.order" [flag]="cardObj.flag" [rating]="cardObj.rating"
                                            [cardArtData]="cardObj.cardArtData" [rtb]="cardObj.rtb" [ctaData]="cardObj.ctaData"
                                            (footerLinkClick)="onPageLinkClick($event, obj?.categoryHeader?.headerText.plaintext)"
                                            [legalLinks]="cardObj.legalLinks"
                                            (checkboxClick)="selectCheckBoxes($event, obj?.categoryHeader?.headerText.plaintext)"
                                            (ctaClick)="onPageLinkClick($event, obj?.categoryHeader?.headerText.plaintext)"></tds-cc-module>
                                        <!-- CARD -->
                                        @if(cardObj?._variation !== 'master'){
                                        <div [innerHTML]="variationEndComment"></div>
                                        }
                                        <!-- VARIATION DATA END -->
                                    } @else {
                                    <div class="w-100 card-container-placeholder" [ngClass]="{'loader': isBannerCallRequired}">
                                        @if (displayBanner) {
                                            <!-- Engagement -->
                                        <tds-engagement-container [items]="cardObj.items"
                                            [template]="cardObj.template"></tds-engagement-container>
                                        }
                                    </div>
                                    }
                                    } @placeholder {
                                    <div class="loader w-100 card-container-placeholder"></div>
                                    }
                                </div>
                            </ng-container>
                        </div>
                        @if (obj['slider'] && obj['sliderContainer']) {
                        <div class="float-icon">
                            <cds-icon idStr="icon-id" type="2021" role="presentation" aria-hidden="true" name="257-chevron-right"
                                pathColor="#04208f" [svgStyle]="{'width.rem': '2.5' , 'height.rem': '2.5' }"></cds-icon>
                        </div>
                        <div class="card-slider" role="list">
                            @for (cardObj of obj['productList']; track cardObj; let k = $index) {
                            <div class="" role="listitem">
                                <button role="button" class="cds-button dot" [ngClass]="{'active': selectedIndex[i] == k}"
                                    [attr.aria-pressed]="selectedIndex[i] == k" attr.aria-label="{{(k+1)}} of {{obj?.productList.length}}"
                                    (click)="focusCard(i, k)" tabindex="0" (keypress)="focusCard(i, k)"></button>
                            </div>
                            }
                        </div>
                        }
                    </div>
                </section>
            </ng-container>
        </section>
        }
        <!-- PRODUCT LIST END -->
    </div>
    <!-- FOOTER BANNER START  -->
    @if(pageDataObj['engagementData']){
    <section id="SAM-container-module" class="container-fluid bg-primary text-white py-5 px-0 gap-3">
        <div class="h-100 w-100 container-xxl d-flex flex-column flex-md-row gap-2 justify-content-between">
            @for(item of pageDataObj['engagementData'];track $index){
            <tds-engagement [engagement]="item.engagement" [template]="item.template"></tds-engagement>
            }
        </div>
    </section>
    }
    <!-- FOOTER BANNER END  -->
    <!-- COMPARE STICKY START -->
    @if(selectedPids.length > 0){
    <div class="sticky-container">
        <tds-compare-card-sticky [selectedPids]="selectedPids" (remove)="selectCheckBoxes($event)"
            (btnClick)="compareBtnClick($event)" (cardArtCliked)="cardArtCliked($event)"></tds-compare-card-sticky>
    </div>
    }
    <!-- COMPARE STICKY END -->
    }
</div>